import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  StripeCheckoutSessionSummaryV1Response,
} from '../models';

/* istanbul ignore next */
export abstract class StripeService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('stripeServiceUrl');
  }

  abstract createCheckoutSession(
    tenantId: string,
    payload: CreateCheckoutSessionRequest,
  ): Observable<CreateCheckoutSessionResponse>;

  abstract getCheckoutSessionSummaryV1(
    tenantId: string,
    stripeAccountId: string,
    stripeSessionId: string,
  ): Observable<StripeCheckoutSessionSummaryV1Response>;
}
